import { AuthService} from '../../services'
import router from '../../router'
const user = JSON.parse(localStorage.getItem('user'))
const initUserState = user ? user : {user_id : null , token : null}

export const AuthModule = {
    namespaced : true,
    state : {
        ...initUserState,
        loading : false
    },
    actions : {
        async login({rootState,commit},form){
            var self = this
            return await new Promise((resolve,reject) => {
                const loading = rootState.AuthModule.loading;
                
                if(!loading){
                    commit('LoadingTrue')
                    const params = {
                        email : form.email,
                        password : form.password,
                        location : form.showroom,
                    }
                    AuthService.login(params).then((response) => {
                        commit('InitUserData', response.data)
                        commit('LoadingFalse');

                        if(response.data.location !== null){
                            router.push({ name: 'welcome' });
                        }
                        resolve(response.data)
                    }).catch((error) => {
                        commit('LoadingFalse')
                        reject(error)
                    })
                }
            })
        },
        async generate({commit},form){
            var self = this
            return await new Promise((resolve,reject) => {
                const loading = loading;
                
                if(!loading){
                    commit('LoadingTrue')
                    const params = {
                        email : form.email,
                        password : form.password,
                        location : form.showroom,
                    }
                    AuthService.login(params).then((response) => {
                        commit('InitUserData', response.data)
                        commit('LoadingFalse');
                        resolve(response.data)
                    }).catch((error) => {
                        commit('LoadingFalse')
                        reject(error)
                    })
                }
            })
        },

        async Logout(){
            return await new Promise(() => {
                localStorage.removeItem('user');
                router.push({ name: 'login'}).catch(() => { });
            })
            
        },

        async SendReset({rootState,commit},email){
            return await new Promise((resolve,reject) => {
                const loading = rootState.AuthModule.loading;
                if (!loading) {
                    commit('LoadingTrue')
                    AuthService.sendReset(email).then((response) => {
                        commit('ClearUserData')
                        commit('LoadingFalse')
                        resolve(response)
                    }).catch((error) => {
                        commit('LoadingFalse')
                        reject(error)
                    })
                }
            })
        },

        async ChangePassword({rootState,commit},payload){
            return await new Promise((resolve, reject) => {
                const loading = rootState.AuthModule.loading;
                if (!loading) {
                    commit('LoadingTrue')
                    AuthService.sendChangePassword(payload).then((response) => {
                        commit('LoadingFalse')
                        resolve(response)
                    }).catch((error) => {
                        commit('LoadingFalse')
                        reject(error)
                    })
                }
            })
            
        },

        
        
    },
    mutations : {
        InitUserData(state,payload){
            state.user = payload
        },
        LoadingFalse(state){
            state.loading = false
        },
        LoadingTrue(state) {
            state.loading = true
        },
        ClearUserData(state){
            state.user = {}
        }
    },
    getters : {
        user : state => state.user,
        Loading : state => state.loading,
    }
}
